var map = {
	"./vfalls_1.jpg": 104,
	"./vfalls_2.jpg": 341,
	"./vfalls_3.jpg": 41,
	"./vfalls_4.jpg": 105,
	"./vfalls_5.jpg": 342,
	"./vfalls_6.jpg": 343,
	"./vfalls_7.jpg": 344
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 350;



//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock/vfalls nonrecursive \.(png|jpe?g|svg)$
// module id = 350
// module chunks = 0